import { styled } from '@mui/material';
import TableRow from '@mui/material/TableRow';
import { RowDataType } from 'types/common/common';
import colors from 'assets/theme/base/colors';

export const StyledTableRow = styled(TableRow)<{ data: RowDataType }>(({
    data,
}) => {
    const cssObject: any = {};

    switch (data.document_status_id) {
        case 1:
            cssObject['& .MuiTableCell-body'] = {
                color: colors.text.secondary,
            };
            break;
        case 2:
            cssObject['& .MuiTableCell-body'] = {
                color: colors.secondary.main,
            };
            break;
        case 3:
            cssObject['& .MuiTableCell-body'] = {
                color: colors.secondary.main,
            };
            break;
        case 4:
            cssObject['& .MuiTableCell-body'] = {
                color: colors.secondary.main,
            };
            break;
        case 5:
            cssObject['& .MuiTableCell-body'] = {
                color: colors.secondary.main,
            };
            break;
        case 6:
            cssObject['& .MuiTableCell-body'] = {
                color: colors.error.main,
            };
            break;
        case 7:
            cssObject['& .MuiTableCell-body'] = {
                color: colors.success.main,
            };
            break;
    }

    return cssObject;
});
